// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { GetLeadTimeApiParameter, getLeadTimeService } from "@werner/App/Services/GetLeadTimeService";

type HandlerType = Handler<
    GetLeadTimeApiParameter & HasOnSuccess<string>,
    {
        apiParameter: GetLeadTimeApiParameter;
        apiResult?: string;
    }
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = (await getLeadTimeService(props.apiParameter)) as string;
    } catch (e) {
        props.apiResult = undefined;
    }
};

export const CallOnSuccess: HandlerType = props => {
    if(props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const XngDispatchBeginLoadShipTos: HandlerType = props => {
    props.dispatch({
        type: "xProductDetails/SetLeadTimeMessage",
        message: props.apiResult,
    } as any);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, CallOnSuccess, XngDispatchBeginLoadShipTos];

const getLeadTime = createHandlerChainRunner(chain, "GetLeadTime");
export default getLeadTime;
